const VIDEO_FILE_EXTENSION_PATTERN = /\.(mp4|webm|mov|m4v|ogv|ogg|avi|mkv|wmv)$/;
const GIF_FILE_EXTENSION_PATTERN = /\.gif$/;
const IMAGE_FILE_EXTENSION_PATTERN = /\.(jpg|jpeg|png|webp|bmp|svg|avif)$/;

function normalizeMediaUrl(mediaUrl = '') {
  return mediaUrl.toString().toLowerCase().trim().split('?')[0].split('#')[0];
}

export function inferMediaKind({ mediaType = '', mediaUrl = '' } = {}) {
  const explicit = mediaType.toString().toLowerCase();

  if (explicit.includes('video')) {
    return 'video';
  }
  if (explicit.includes('gif')) {
    return 'gif';
  }
  if (explicit.includes('image')) {
    return 'image';
  }

  const normalizedUrl = normalizeMediaUrl(mediaUrl);
  if (VIDEO_FILE_EXTENSION_PATTERN.test(normalizedUrl)) {
    return 'video';
  }
  if (GIF_FILE_EXTENSION_PATTERN.test(normalizedUrl)) {
    return 'gif';
  }
  if (IMAGE_FILE_EXTENSION_PATTERN.test(normalizedUrl)) {
    return 'image';
  }

  return '';
}
